var lib_core = require("lib-core");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

var CustomSmdPadGeneratorInteractionModel = {
    addCustomSmdPadGeneratorInteractionModel: function() {
        var self = this;    
        this.hasCustomFootprint = this.shadow("hasCustomFootprint",
            function() {
                return self.data.hasCustomFootprint();
            },
            function(value) {
                return self.data.hasCustomFootprint(value);;
            },
            [
                self.data.hasCustomFootprint
            ]
        );

        this.customPadWidth = this.shadow("customPadWidth",
            function() {
                return self.data.customPadWidth() / self.getUnitFactor();
            },
            function(value) {
                return self.data.customPadWidth(parseFloat(value) * self.getUnitFactor());
            },
            [self.data.customPadWidth, this.userSettingsModel.distanceUnit]
        );

        this.customOddPadWidth = this.shadow("customOddPadWidth",
            function() {
                return self.data.customOddPadWidth() / self.getUnitFactor();
            },
            function(value) {
                return self.data.customOddPadWidth(parseFloat(value) * self.getUnitFactor());
            },
            [self.data.customOddPadWidth, this.userSettingsModel.distanceUnit]
        );

        this.customPadLength = this.shadow("customPadLength",
            function() {
                return self.data.customPadLength() / self.getUnitFactor();
            },
            function(value) {
                return self.data.customPadLength(parseFloat(value) * self.getUnitFactor());
            },
            [self.data.customPadLength, this.userSettingsModel.distanceUnit]
        );

        this.customOddPadLength = this.shadow("customOddPadLength",
            function() {
                return self.data.customOddPadLength() / self.getUnitFactor();
            },
            function(value) {
                return self.data.customOddPadLength(parseFloat(value) * self.getUnitFactor());
            },
            [self.data.customOddPadLength, this.userSettingsModel.distanceUnit]
        );

        this.customPadToPadGap = this.shadow("customPadToPadGap",
            function() {
                return self.data.customPadToPadGap() / self.getUnitFactor();
            },
            function(value) {
                return self.data.customPadToPadGap(parseFloat(value) * self.getUnitFactor());
            },
            [self.data.customPadToPadGap, this.userSettingsModel.distanceUnit]
        );

        this.customPadToPadGap1 = this.shadow("customPadToPadGap1",
            function() {
                return self.data.customPadToPadGap1() / self.getUnitFactor();
            },
            function(value) {
                return self.data.customPadToPadGap1(parseFloat(value) * self.getUnitFactor());
            },
            [self.data.customPadToPadGap1, this.userSettingsModel.distanceUnit]
        );

        this.customPadSpan1 = this.shadow("customPadSpan1",
            function() {
                return self.data.customPadSpan1() / self.getUnitFactor();
            },
            function(value) {
                return self.data.customPadSpan1(parseFloat(value) * self.getUnitFactor());
            },
            [self.data.customPadSpan1, this.userSettingsModel.distanceUnit]
        );

        this.customPadSpan2 = this.shadow("customPadSpan2",
            function() {
                return self.data.customPadSpan2() / self.getUnitFactor();
            },
            function(value) {
                return self.data.customPadSpan2(parseFloat(value) * self.getUnitFactor());
            },
            [self.data.customPadSpan2, this.userSettingsModel.distanceUnit]
        );

        this.customPadPitch = this.shadow("customPadPitch",
            function() {
                return self.data.customPadPitch() / self.getUnitFactor();
            },
            function(value) {
                return self.data.customPadPitch(parseFloat(value) * self.getUnitFactor());
            },
            [self.data.customPadPitch, this.userSettingsModel.distanceUnit]
        );

        this.customPadDiameter = this.shadow("customPadDiameter",
            function() {
                return self.data.customPadDiameter() / self.getUnitFactor();
            },
            function(value) {
                return self.data.customPadDiameter(parseFloat(value) * self.getUnitFactor());
            },
            [self.data.customPadDiameter, this.userSettingsModel.distanceUnit]
        );

        this.pinPitch1 = this.shadow("pinPitch1",
            function() {
                return self.data.pinPitch1() / self.getUnitFactor();
            },
            function(value) {
                return self.data.pinPitch1(parseFloat(value) * self.getUnitFactor());
            },
            [self.data.pinPitch1, this.userSettingsModel.distanceUnit]
        );

        this.getInspectorElementForEnablingCustomFootprint = function() {
            return [PackageGeneratorInspectorConfig.getCheckBox(this.LCLZ('customFootprint', 'Custom Footprint'), this.hasCustomFootprint)];
        };

        this.getInspectorElementForCustomFootprintImage = function(customFootprintImage) {
            return [PackageGeneratorInspectorConfig.getImage(customFootprintImage, this.hasCustomFootprint)];   
        };

        this.getInspectorElementForCustomFootprintNormalPadSettings = function() {

            var customPadLength = PackageGeneratorInspectorConfig.getValueFixedUnit('l', this.LCLZ('customPadLength', 'Custom Pad Length'), this.customPadLength, this.userSettingsModel.distanceUnit, this.hasCustomFootprint);
            var customPadWidth = PackageGeneratorInspectorConfig.getValueFixedUnit('c', this.LCLZ('customPadWidth', 'Custom Pad Width'), this.customPadWidth, this.userSettingsModel.distanceUnit, this.hasCustomFootprint);
            return [customPadLength, customPadWidth]
        };

        this.getInspectorElementForPadGapInCustomFootprint = function() {
            return [PackageGeneratorInspectorConfig.getValueFixedUnit('g', this.LCLZ('customPadGap', 'Custom Pad To Pad Gap'), this.customPadToPadGap, this.userSettingsModel.distanceUnit, this.hasCustomFootprint)];
        };

        this.getInspectorElementForPadGap1InCustomFootprint = function() {
            return [PackageGeneratorInspectorConfig.getValueFixedUnit('g1', this.LCLZ('customPadGap1', 'Custom Pad To Pad Gap 1'), this.customPadToPadGap1, this.userSettingsModel.distanceUnit, this.hasCustomFootprint)];
        };

        this.getInspectorElementForOddPadWidthInCustomFootprint = function() {
            return [PackageGeneratorInspectorConfig.getValueFixedUnit('c1', this.LCLZ('customOddPadWidth', 'Custom Odd Pad Width'), this.customOddPadWidth, this.userSettingsModel.distanceUnit, this.hasCustomFootprint)];
        };
        
        this.getInspectorElementForOddPadLengthInCustomFootprint = function() {
            return [PackageGeneratorInspectorConfig.getValueFixedUnit('l1', this.LCLZ('customOddPadLength', 'Custom Odd Pad Length'), this.customOddPadLength, this.userSettingsModel.distanceUnit, this.hasCustomFootprint)];
        };

        this.getInspectorElementForPadSpan1InCustomFootprint = function() {
            return [PackageGeneratorInspectorConfig.getValueFixedUnit('z', this.LCLZ('customPadSpan1', 'Custom Pad Span 1'), this.customPadSpan1, this.userSettingsModel.distanceUnit, this.hasCustomFootprint)];
        };
        this.getInspectorElementForPadSpan2InCustomFootprint = function() {
            return [PackageGeneratorInspectorConfig.getValueFixedUnit('z1', this.LCLZ('customPadSpan2', 'Custom Pad Span 2'), this.customPadSpan2, this.userSettingsModel.distanceUnit, this.hasCustomFootprint)];
        };
        this.getInspectorElementForPadPitchInCustomFootprint = function() {
            return [PackageGeneratorInspectorConfig.getValueFixedUnit('p', this.LCLZ('customPadPitch', 'Custom Pad Pitch'), this.customPadPitch, this.userSettingsModel.distanceUnit, this.hasCustomFootprint)];
        };
        this.getInspectorElementForPadDiameterInCustomFootprint = function() {
            return [PackageGeneratorInspectorConfig.getValueFixedUnit('b1', this.LCLZ('customPadDiameter', 'Custom Pad Diameter'), this.customPadDiameter, this.userSettingsModel.distanceUnit, this.hasCustomFootprint)];
        };
        this.getInspectorElementForPinPitch1 = function() {
            return [PackageGeneratorInspectorConfig.getValueFixedUnit('e1', this.LCLZ('pinPitch1', 'Pin Pitch 1'), this.pinPitch1, this.userSettingsModel.distanceUnit, this.hasCustomFootprint)];
        };
    }
};

module.exports = CustomSmdPadGeneratorInteractionModel;